import React from 'react'

import ActionButton, {
  ActionButtonIcon,
  ActionButtonSize,
  ActionButtonType,
} from '$extensionSrc/components/ActionButton'

import './FormSubmitButton.scss'

export default function FormSubmitButton({
  children,
  isValid,
  iconName = null,
}: React.PropsWithChildren<{
  isValid: boolean
  iconName?: ActionButtonIcon | null
}>) {
  return (
    <div className="FormSubmitButton">
      <ActionButton
        type={ActionButtonType.PRIMARY}
        size={ActionButtonSize.LARGE}
        disabled={!isValid}
        htmlType="submit"
        iconName={iconName}
      >
        {children}
      </ActionButton>
    </div>
  )
}
